<template>
    <nav class="navigation-links-nav navigation-links-root-class-name17">
        <span class="navigation-links-text navigation-Link" @click="scrollTo('.home-games')">{{ lineGames }}</span>
        <span class="navigation-links-text1 navigation-Link" @click="scrollTo('.home-community')">{{ lineCommunity }}</span>
        <span class="navigation-links-text2 navigation-Link" @click="scrollTo('.home-container5')">{{ lineContact }}</span>
    </nav>
</template>

<script>
    import api_fetch from "../api_fetch";

    export default {
        data() {
            return {
                lineGames: null,
                lineCommunity: null,
                lineContact: null
            };
        },
        created() {
            api_fetch('api/App').then((data) => {
                this.lineGames = data.attributes.LineGames;
                this.lineCommunity = data.attributes.LineCommunity;
                this.lineContact = data.attributes.LineContact;
            });
        },
        methods: {
            scrollTo(selector) {
                document.querySelector(selector).scrollIntoView({
                    behavior: 'smooth'
                });
            }
        }
    }
</script>

<style scoped>
    .navigation-links-nav {
        flex: 0 0 auto;
        display: flex;
        align-items: center;
        flex-direction: row;
    }

    .navigation-Link {
        color: var(--dl-color-scheme-white);
        cursor: pointer;
        transition: 0.3s;
        margin: 0 var(--dl-space-space-oneandhalfunits);
    }

    .navigation-Link:hover {
        color: var(--dl-color-scheme-pink);
    }

    @media (max-width: 767px) {
        .navigation-Link {
            margin: 0 var(--dl-space-space-halfunit);
        }
    }
</style>
